var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.832 11.6663V6.99967C18.832 5.762 19.3237 4.57501 20.1989 3.69984C21.074 2.82467 22.261 2.33301 23.4987 2.33301H39.832C41.0697 2.33301 42.2567 2.82467 43.1319 3.69984C44.007 4.57501 44.4987 5.762 44.4987 6.99967V34.9997C44.4987 36.2374 44.007 37.4243 43.1319 38.2995C42.2567 39.1747 41.0697 39.6663 39.832 39.6663H23.4987C22.261 39.6663 21.074 39.1747 20.1989 38.2995C19.3237 37.4243 18.832 36.2374 18.832 34.9997V30.333",
    stroke: "black",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.499 21H2.49902M2.49902 21L9.49902 14M2.49902 21L9.49902 28",
    stroke: "#7663EB",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.20c1256d0836de5b78ddf927c30e0581.svg";
export { ForwardRef as ReactComponent };